// extracted by mini-css-extract-plugin
export var logo = "index-module--logo--2CEbj";
export var freshersHeroSection = "index-module--freshersHeroSection--13Sy4";
export var container = "index-module--container--18MSq";
export var title = "index-module--title--2aQhZ";
export var subtitle = "index-module--subtitle--2-O0o";